import Dropdown from '../global/Dropdown';

export default function ClientProjectDropdowns({
  clientOptions,
  projectOptions,
  selectedClientId,
  selectedProjectId,
  onClientChange,
  onProjectChange,
  projectDisabled,
  projectPlaceholder = 'Select project',
  rootClassName = 'header-scope-dropdown',
}) {
  return (
    <>
      <div className="filter-dropdown-outer header-dropdown-outer">
        <Dropdown
          options={clientOptions}
          value={selectedClientId}
          onChange={onClientChange}
          placeholder="Select client"
          ariaLabel="Select client"
          rootClassName={rootClassName}
        />
      </div>
      <div className="filter-dropdown-outer header-dropdown-outer">
        <Dropdown
          options={projectOptions}
          value={selectedProjectId}
          onChange={onProjectChange}
          disabled={projectDisabled}
          placeholder={projectPlaceholder}
          ariaLabel="Select project"
          rootClassName={rootClassName}
        />
      </div>
    </>
  );
}
